"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AppPageHeader;
const jsx_runtime_1 = require("react/jsx-runtime");
const ama_logo_svg_1 = __importDefault(require("@/assets/img/ama_logo.svg"));
const MenuContext_1 = require("@/components/menu/MenuContext");
const configService_1 = require("@/service/configService");
const react_router_dom_1 = require("react-router-dom");
const getPageTitle = () => {
    const boersedatenPageMatch = (0, react_router_dom_1.useMatch)("/reports/boerse");
    const wochenpreisePageMatch = (0, react_router_dom_1.useMatch)("/reports/preise");
    const milchanlieferungPageMatch = (0, react_router_dom_1.useMatch)("/reports/milch");
    const flaechenauswertungPageMatch = (0, react_router_dom_1.useMatch)("/reports/flaechen");
    let title = "AMA Marktdaten Vergleich";
    if (boersedatenPageMatch) {
        title = "Börsedaten Getreide";
    }
    else if (wochenpreisePageMatch) {
        title = "Fleisch/Eier Wochenpreise";
    }
    else if (milchanlieferungPageMatch) {
        title = "Milchanlieferung";
    }
    else if (flaechenauswertungPageMatch) {
        title = "Flächenauswertung";
    }
    return title + (!(0, configService_1.isProductionEnvironment)() ? ` (${(0, configService_1.getEnvironment)().toUpperCase()})` : "");
};
/*
const getPageTitle = () => {
    const boersedatenPageMatch = useMatch("/reports/boerse");
    const wochenpreisePageMatch = useMatch("/reports/preise");
    const milchanlieferungPageMatch = useMatch("/reports/milch");
    const flaechenauswertungPageMatch = useMatch("/reports/flaechen");
    let title = "AMA Marktdaten Vergleich";
    if (boersedatenPageMatch) {
        title = "Börsedaten Getreide";
    } else if (wochenpreisePageMatch) {
        title = "Fleisch/Eier Wochenpreise";
    } else if (milchanlieferungPageMatch) {
        title = "Milchanlieferung";
    } else if (flaechenauswertungPageMatch) {
        title = "Flächenauswertung";
    }
    return title + (!isProductionEnvironment() ? ` (${getEnvironment().toUpperCase()})` : "");
}
*/
function getPageTitleFromMenuState(menuItem) {
    console.log("menuItem=", menuItem);
    let title = "";
    if (menuItem == "home" || menuItem == "marktdaten" || menuItem == "info") {
        title = "AMA Marktdaten Vergleich";
    }
    else if (menuItem == "boerse") {
        title = "Börsedaten Getreide";
    }
    else if (menuItem == "preise") {
        title = "Fleisch/Eier Wochenpreis";
    }
    else if (menuItem == "milch") {
        title = "Milchanlieferung";
    }
    else if (menuItem == "flaechen") {
        title = "Flächenauswertung";
    }
    else if (menuItem == "dashboards") {
        title = "Dashboards";
    }
    return title + (!(0, configService_1.isProductionEnvironment)() ? ` (${(0, configService_1.getEnvironment)().toUpperCase()})` : "");
}
function AppPageHeader() {
    const { menuItem } = (0, MenuContext_1.useMenu)();
    //const title = getPageTitle();
    const title = getPageTitleFromMenuState(menuItem);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row justify-between items-center h-32 pl-5 pr-0 sm:px-[var(--page-px)] bg-[var(--header-background)] print:px-0 print:h-auto", children: [(0, jsx_runtime_1.jsx)("h1", { className: "font-light text-2xl sm:text-4xl print:text-[18px] print:font-bold", children: title }), (0, jsx_runtime_1.jsx)("a", { href: "https://www.ama.at/marktinformationen/aktuelle-marktinformationen", children: (0, jsx_runtime_1.jsx)("img", { className: "h-14 sm:h-20 print:h-11", title: "AgrarMarkt Austria", alt: "AMA Logo", src: ama_logo_svg_1.default }) })] }));
}
